import React, { useState, useEffect } from "react"
import CustomDialog, { CustomDialogProps } from "../Atoms/CustomDialog"
import { withFormController } from "../Molecules/FormController"
import FileUploadButton from "../Organisms/FileUploadButton"
import placeholder from "assets/images/placeholder.png"
import CustomButton from "../Atoms/CustomButton"
interface FileUploadDialogProps extends CustomDialogProps {
  photos: any[]
  path: string
  value: any[]
  onChange: (path: string, value: any) => void
  onDelete?: (file: any) => void
  [key: string]: any
}

const FileUploadDialog = ({
  path,
  value,
  onChange,
  photos,
  isOpen,
  onClose,
  light,
  onDelete,
  disabled,
  ...title
}: FileUploadDialogProps) => {
  const [selectedPhoto, setPhoto] = useState<any>(value?.[0])
  useEffect(() => {
    setPhoto((prev: any) => prev ?? value?.[0])
  }, [value])

  return (
    <CustomDialog
      icon="camera"
      title="Select Photos"
      light={light}
      isOpen={isOpen}
      onClose={onClose}
      width="45%"
      {...title}
    >
      <div className="grid grid-cols-3 gap-4">
        <div>
          <FileUploadButton
            disabled={disabled}
            className="mb-3"
            value={value}
            onChange={(_: any, files: any) => {
              const parsedFiles = Object.values(files)
              setPhoto(parsedFiles?.[0])
              onChange(path, parsedFiles)
            }}
          />
        </div>
      </div>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-9">
          <div style={{ position: "relative" }}>
            <img
              style={{
                border: "3px solid #6FCF97",
                borderRadius: 10,
                cursor: "pointer",
                marginBottom: "1rem",
                objectFit: "cover",
                width: "100%",
                height: 360,
              }}
              src={selectedPhoto?.url ?? placeholder}
              alt="Highlight"
            />
            {selectedPhoto && (
              <CustomButton
                onClick={e => {
                  onChange(
                    path,
                    value?.filter(va => va?.url !== selectedPhoto?.url)
                  )
                  onDelete?.(selectedPhoto)
                  setPhoto(null)
                }}
                className="vt-file-upload-dialog-button"
                icon="trash"
                intent="danger"
              />
            )}
          </div>
        </div>
        <div className="col-span-3">
          <div
            style={{
              height: "40vh",
              overflow: "auto",
            }}
          >
            {value?.map?.((v, idx) => {
              return (
                <div
                  key={v?.id ?? `photo-${idx}`}
                  style={{ position: "relative" }}
                >
                  <img
                    onClick={e => setPhoto(v)}
                    style={{
                      border:
                        selectedPhoto?.id === v?.id
                          ? "3px solid #6FCF97"
                          : undefined,
                      borderRadius: 10,
                      cursor: "pointer",
                      marginBottom: "1rem",
                      objectFit: "cover",
                      width: "100%",
                      height: "100%",
                    }}
                    key={v?.id}
                    src={v?.url}
                    alt="Description"
                  ></img>
                  <CustomButton
                    onClick={e => {
                      onDelete?.(v)
                      onChange(
                        path,
                        value?.filter(va => va?.url !== v?.url)
                      )
                      if (selectedPhoto?.url === v.url) setPhoto(null)
                    }}
                    className="vt-file-upload-dialog-button"
                    icon="trash"
                    intent="danger"
                  />
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </CustomDialog>
  )
}
FileUploadDialog.defaultProps = {
  light: true,
}
export default withFormController(FileUploadDialog)
